<script>
  import ToggleInput from "@/components/atoms/ToggleInput.vue";
  import LocationsFilters from "../LocationsFilter/LocationsFilters.vue";
  import { fetchOffices } from "@/services/fetchOffices";
  const { apps_icons } = require("@/common/apps");

  const POLICY_APPS = ["autologin", "statistics", "website", "reservations"];
  const INACTIVOS_CITY = { _id: "inactivos", cityName: "Inactivos" };

  export default {
    name: "PoliceCities",
    components: { ToggleInput, LocationsFilters },
    props: {
      policy: { type: Object, default: () => ({}) },
      user: { type: Object, default: () => ({}) },
    },
    data() {
      const appStates = {};
      POLICY_APPS.forEach((key) => {
        appStates[key] = { enabled: false, locationsSelected: [] };
      });
      const forceCloseCounters = {};
      POLICY_APPS.forEach((key) => {
        forceCloseCounters[key] = 0;
      });
      return {
        appStates,
        forceCloseCounters,
        citiesData: [],
        officesData: [],
        observer: null,
      };
    },
    computed: {
      policyApps() {
        return POLICY_APPS.map((key) => {
          const app = apps_icons.find((a) => a.key === key);
          return { key, name: app?.name || key, icon: app?.icon };
        });
      },
      availableCities() {
        if (this.citiesData.length) return this.citiesData;
        const storeCities = this.$store.getters["cities/getData"];
        const mapped = Array.isArray(storeCities) ? storeCities : [];
        return mapped.length ? mapped : null;
      },
      availableOffices() {
        if (this.officesData.length) return this.officesData;
        const storeOffices = this.$store.getters["offices/getData"];
        const mapped = Array.isArray(storeOffices) ? storeOffices : [];
        return mapped.length ? mapped : null;
      },
      citiesForStatistics() {
        const base = this.availableCities || [];
        return [...base, INACTIVOS_CITY];
      },
    },
    methods: {
      async initLocationsData() {
        try {
          const [cities, offices] = await Promise.all([this.$store.state.cities.data, fetchOffices()]);
          this.citiesData = Array.isArray(cities) ? cities : [];
          this.officesData = Array.isArray(offices) ? offices : [];
          this.loadPreviousSelections();
        } catch {
          this.citiesData = [];
          this.officesData = [];
        }
      },
      loadPreviousSelections() {
        const policyPayload = this.user.polices?.[this.policy.key]?.payload;
        if (!policyPayload || typeof policyPayload !== "object") return;

        POLICY_APPS.forEach((appKey) => {
          const appPayload = policyPayload[appKey];
          if (!appPayload || typeof appPayload !== "object") return;

          const locations = [];
          Object.entries(appPayload).forEach(([cityName, offices]) => {
            if (Array.isArray(offices) && offices.length > 0) {
              offices.forEach((officeName) => {
                const office = this.officesData.find((o) => o.officeName === officeName && o.cityName === cityName);
                if (office) locations.push({ ...office, name: office.officeName });
              });
            } else {
              let city = this.citiesData.find((c) => c.cityName === cityName || c.name === cityName);
              if (!city && appKey === "statistics" && cityName === "Inactivos") city = INACTIVOS_CITY;
              if (city) locations.push({ ...city, name: city.cityName || city.name });
            }
          });

          this.appStates[appKey].locationsSelected = locations;
          this.appStates[appKey].enabled = locations.length > 0;
        });
      },
      buildAppLocations(locationsSelected) {
        const selectedCities = locationsSelected
          .filter((loc) => !loc?.cityId)
          .map((city) => city?.cityName || city?.name)
          .filter(Boolean);

        const selectedOffices = locationsSelected
          .filter((loc) => loc?.cityId)
          .map((office) => ({
            cityName: office?.cityName,
            officeName: office?.officeName || office?.name,
          }))
          .filter((o) => o.cityName && o.officeName);

        const officesByCity = selectedOffices.reduce((acc, office) => {
          if (!acc[office.cityName]) acc[office.cityName] = [];
          acc[office.cityName].push(office.officeName);
          return acc;
        }, {});

        const result = {};
        selectedCities.forEach((cityName) => {
          if (!officesByCity[cityName]) result[cityName] = [];
        });
        Object.entries(officesByCity).forEach(([cityName, offices]) => {
          result[cityName] = offices;
        });
        return result;
      },
      buildResult() {
        const allOptionsSeleted = {};
        POLICY_APPS.forEach((appKey) => {
          const state = this.appStates[appKey];
          if (state.enabled && state.locationsSelected.length > 0) {
            allOptionsSeleted[appKey] = this.buildAppLocations(state.locationsSelected);
          }
        });
        return { allOptionsSeleted };
      },
      closeOtherPickers(openedKey) {
        POLICY_APPS.forEach((key) => {
          if (key !== openedKey) this.forceCloseCounters[key]++;
        });
      },
      handleToggleChange(appKey, value) {
        this.appStates[appKey].enabled = value;
        if (!value) {
          this.appStates[appKey].locationsSelected = [];
        }
        this.emitResult();
      },
      handleLocationsChange(appKey, locations) {
        this.appStates[appKey].locationsSelected = locations;
        this.appStates[appKey].enabled = locations.length > 0;
        this.emitResult();
      },
      emitResult() {
        this.$emit("result-updated", { politic: this.buildResult() });
      },
      scrollToModal() {
        this.$nextTick(() => {
          const modal = this.$el.querySelector(".locationsFilter__selectModal");
          if (modal) {
            let scrollContainer = this.$el.parentElement;
            while (scrollContainer) {
              const hasScroll = scrollContainer.scrollHeight > scrollContainer.clientHeight;
              const overflowY = window.getComputedStyle(scrollContainer).overflowY;
              if (hasScroll && (overflowY === "auto" || overflowY === "scroll")) break;
              scrollContainer = scrollContainer.parentElement;
            }
            if (scrollContainer) {
              const modalRect = modal.getBoundingClientRect();
              const containerRect = scrollContainer.getBoundingClientRect();
              if (modalRect.bottom > containerRect.bottom) {
                scrollContainer.scrollBy({ top: modalRect.bottom - containerRect.bottom + 20, behavior: "smooth" });
              }
            }
          }
        });
      },
      setupModalObserver() {
        this.observer = new MutationObserver(() => {
          if (this.$el.querySelector(".locationsFilter__selectModal")) {
            this.scrollToModal();
          }
        });
        this.observer.observe(this.$el, { childList: true, subtree: true });
      },
    },
    mounted() {
      this.initLocationsData();
      this.setupModalObserver();
    },
    beforeDestroy() {
      if (this.observer) this.observer.disconnect();
    },
  };
</script>

<template>
  <div class="policesCities">
    <div class="policesCities__header">
      <div class="policesCities__label">Visualización de ciudades</div>
      <div class="policesCities__text--short">Habilita por aplicativo el acceso a información de otras ciudades.</div>
    </div>

    <div class="policesCities__apps">
      <div v-for="(app, index) in policyApps" :key="app.key" class="policesCities__appItem" :style="{ zIndex: policyApps.length - index, position: 'relative' }">
        <div class="policesCities__appRow">
          <div class="policesCities__appInfo">
            <img :src="app.icon" class="policesCities__appIcon" alt="" />
            <span class="policesCities__appName">{{ app.name }}</span>
          </div>
          <ToggleInput :value="appStates[app.key].enabled" @input="handleToggleChange(app.key, $event)" label="" />
        </div>
        <transition name="slide-down">
          <div v-if="appStates[app.key].enabled" class="policesCities__filterWrapper">
            <LocationsFilters
              class="policesCities__filterLocation"
              :locations-selected="appStates[app.key].locationsSelected"
              :force-close="forceCloseCounters[app.key]"
              placeholder="Agrega ciudades"
              icon="cities"
              :cities="app.key === 'statistics' ? citiesForStatistics : availableCities"
              :offices="availableOffices"
              @picker-opened="closeOtherPickers(app.key)"
              @upd-locations="handleLocationsChange(app.key, $event)" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .policesCities {
    @include Flex(column, flex-start, flex-start);
    padding: 12px;
    gap: 12px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    position: relative;
    overflow: visible;

    &__filterWrapper {
      width: 100%;
      overflow: visible;
    }

    .slide-down {
      &-enter-active,
      &-leave-active {
        transition:
          max-height 0.25s ease,
          opacity 0.2s ease;
        overflow: hidden;
        max-height: 200px;
      }
      &-enter,
      &-leave-to {
        max-height: 0;
        opacity: 0;
      }
    }

    .locationsFilter {
      max-width: unset;
      .locationsList {
        background-color: #fff;
        border-radius: 8px;
        padding: 6px 10px;
        border: 1px solid #e0e0e0;
        box-shadow: none;
        &__placeholder {
          font-family: $newFont_regular;
          font-weight: 400;
          font-size: 15px;
          color: rgba(41, 41, 41, 0.5);
        }
      }
      .itemSelected {
        background-color: #eeeeee;
      }
    }
    &__header {
      @include Flex(column, flex-start, flex-start);
      gap: 4px;
      width: 100%;
    }

    &__label {
      font-size: 16px;
      font-family: $newFont_medium;
      font-weight: 500;
    }

    &__text--short {
      font-size: 13px;
      font-family: $newFont_regular;
      color: #595959;
    }

    &__notice {
      @include Flex(row, flex-start, center);
      gap: 6px;
      font-size: 13px;
      font-family: $newFont_regular;
      color: #595959;
      padding: 0 2px;
    }

    &__noticeIcon {
      font-size: 14px;
      flex-shrink: 0;
    }

    &__apps {
      @include Flex(column, flex-start, flex-start);
      width: 100%;
      gap: 0;
    }

    &__appItem {
      @include Flex(column, flex-start, flex-start);
      width: 100%;
      padding: 12px 0;
      gap: 12px;
      border-top: 1px solid #e5e5e5;

      &:last-child {
        padding-bottom: 0;
      }
    }

    &__appRow {
      @include Flex(row, space-between, center);
      width: 100%;
    }

    &__appInfo {
      @include Flex(row, flex-start, center);
      gap: 12px;
    }

    &__appIcon {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      object-fit: cover;
    }

    &__appName {
      font-size: 15px;
      font-family: $newFont_regular;
      font-weight: 400;
    }
  }
</style>
